import { useEffect } from "react";

type LegacySyncProps = {
  onSync: () => void;
};

export function LegacySync({ onSync }: LegacySyncProps) {
  useEffect(() => {
    const handler = () => onSync();
    window.addEventListener("tojims:state", handler);
    window.addEventListener("tojims:view", handler);
    window.addEventListener("tojims:dashboard", handler);
    return () => {
      window.removeEventListener("tojims:state", handler);
      window.removeEventListener("tojims:view", handler);
      window.removeEventListener("tojims:dashboard", handler);
    };
  }, [onSync]);
  return null;
}
